"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuEnregistrerExcelSimple = void 0;
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importDefault(require("react"));
const file_saver_1 = __importDefault(require("file-saver"));
const clickSaveExcelSimple = (url_prefix, data) => {
    const root = window.location.href;
    let url = root + url_prefix + 'sankey/save_excel_simple';
    const fetchData = {
        method: 'POST',
        body: JSON.stringify(data)
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        file_saver_1.default.saveAs(newBlob, 'sankey.xlsx');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = root + url_prefix + 'sankey/clean_excel';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
const MenuEnregistrerExcelSimple = (url_prefix, data) => {
    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => clickSaveExcelSimple(url_prefix, data) }, "Excel Simple");
};
exports.MenuEnregistrerExcelSimple = MenuEnregistrerExcelSimple;
